//
// Javascript for the BootstrapSelect input control
//
//  Matt Smith
//
HEIJS.registerNamespace("HEIJS.Controls");
HEIJS.Controls.BootstrapSelect = function (selects)
{
  selects = selects || $('select.heiBootstrapSelect');
  selects.each(function () {
    $(this).addClass('heiBootstrapSelect');

    if ($('option[data-hidden="true"]', this).length === 0 && !this.multiple) { //don't add the hidden empty option to multiple selects
      $(this).addClass('hasHiddenFirstOption').prepend('<option data-hidden="true"></option>');
    }  

    if (!$(this).hasClass('show-menu-arrow')) {
      $(this).addClass('show-menu-arrow');
    }
    
    var includeLiveSearch = this.dataset.liveSearch == null ? true : JSON.parse(this.dataset.liveSearch);

    $(this)
      .addClass(includeLiveSearch ? '' : 'noLiveSearch')
      .selectpicker({
        showTick: this.dataset.showTick == null ? true : JSON.parse(this.dataset.showTick), 
        liveSearch: includeLiveSearch, 
        liveSearchPlaceholder: this.dataset.liveSearchPlaceholder == null ? 'Search...' : this.dataset.liveSearchPlaceholder
      })
      .on('change', function () {
        var $this = $(this);
        var val = $this.val();
        var hasValue = !!val && (!$.isArray(val) || val.length > 0);
        $this.parents('div.heiBootstrapSelect:not(.heiInput):first').toggleClass('noValue', !hasValue);
      })
      .trigger('change');
  });
};

$(document).ready(function () { 
  $(document).on('mousewheel', 'ul.dropdown-menu', function (e) { //don't scroll the parent container when scrolling the ddl
    if (this.scrollHeight === $(this).height()) {
      return true;
    }

    return (this.scrollTop !== 0 || e.deltaY <= 0) && (this.scrollHeight !== (this.scrollTop + $(this).outerHeight()) || e.deltaY >= 0);
  });

  new HEIJS.Controls.BootstrapSelect($('select.heiBootstrapSelect:not(.bypassAutoInit):not(.heiInput)')); 
});